import { render, staticRenderFns } from "./ConvenioPrestacaoContasFinal.vue?vue&type=template&id=f15e0256&"
import script from "./ConvenioPrestacaoContasFinal.vue?vue&type=script&lang=js&"
export * from "./ConvenioPrestacaoContasFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports